<template>

        <div>
            <dialog-add-user ref="dialogAddUser"></dialog-add-user>

            <div class="float-right ml-5 -mt-1">
                <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddUser.createUser(); $refs.dialogAddUser.show();" style="margin-top: 4px"><i class="mdi mdi-plus mr-2"> </i> Add user</div>

                <!-- <div class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="$router.push('/plans')" style="margin-top: -5px;"><i class="fa fa-building mr-2"> </i> Manage plans</div> -->
            </div>

            <h1 class="text-lg font-semibold mb-3">Users</h1>

            <hr class="border-b border-gray-100 mb-3" />

            <v-skeleton-loader
                    v-if="fetchingUsers"
                    type="article, article, article"
            ></v-skeleton-loader>

            <div class="dashboard-box" v-if="!fetchingUsers && users.length == 0">
                <v-card class="pa-2" tile>
                    <div class="p-3">
                        <br /><br /><br /><br />

                        <div class="dashboard-box-iconsquare">
                            <div class="dashboard-box-icon-background"></div>
                            <div class="dashboard-box-icon">
                                <i class="mdi mdi-accounts"></i>
                            </div>
                        </div>

                        <div style="text-align: center">
                            <div class="pt-2 pb-2">
                                <strong>No Users Yet</strong>
                            </div>

                            <div class="text-sm mb-4 text-gray-600">
                                You have no users yet. Use our tools to add users.
                            </div>

                            <br />

                            <div
                                    class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer"
                                    @click="
                  $refs.dialogAddUser.createUser();
                  $refs.dialogAddUser.show();
                "
                                    style="margin-top: -5px"
                            >
                                <i class="mdi mdi-plus mr-2"></i> Add user
                            </div>
                        </div>

                        <br /><br /><br /><br /><br />
                    </div>
                </v-card>
            </div>

            <template v-if="!fetchingUsers && users.length > 0">
            
                <div v-if="$vuetify.breakpoint.mobile" class="mt-7">
                <div class="flex flex-row flex-wrap mb-4">
                    <div
                            v-for="user in sortedUsers"
                            :key="user.id"
                            class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-4"
                    >
                        <v-card class="pa-2" tile>
                            <div class="p-3">
                                <div class="dashboard-box-menu-actions">
                                    <v-menu bottom left>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                            dark
                                                            icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            class="ml-3"
                                                            color="grey darken-1"
                                                    >
                                                        <i class="mdi mdi-dots-vertical"></i>
                                                    </v-btn>
                                                </template>

                                                <v-list class="table-menu-actions">
                                                    <v-list-item class="hover:bg-gray-200"
                                                        v-show="user.settings.role"
                                                    ><v-list-item-title
                                                    ><a
                                                            href="javascript: void(0);"
                                                            @click="
                                    $refs.dialogAddUser.editUser(user);
                                    $refs.dialogAddUser.show();
                                  "
                                                    ><span class="table-menu-action-icon"
                                                    ><i class="mdi mdi-pencil-outline"></i
                                                    ></span>
                                                        Edit</a
                                                    ></v-list-item-title
                                                    ></v-list-item
                                                    >
                                                    <v-list-item class="hover:bg-gray-200"
                                                    ><v-list-item-title
                                                    ><a
                                                            href="javascript: void(0);"
                                                            @click="checkResetPassword(user);"
                                                    ><span class="table-menu-action-icon"
                                                    ><i class="mdi mdi-logout"></i
                                                    ></span>
                                                        Resend Password</a
                                                    ></v-list-item-title
                                                    ></v-list-item
                                                    >
                                                    <v-list-item
                                                            v-if="user.status == 1"
                                                            class="hover:bg-gray-200"
                                                    ><v-list-item-title
                                                    ><a
                                                            href="javascript: void(0);"
                                                            @click="disableAccess(user)"
                                                    ><span class="table-menu-action-icon"
                                                    ><i class="mdi mdi-close"></i
                                                    ></span>
                                                        Disable Access</a
                                                    ></v-list-item-title
                                                    ></v-list-item
                                                    >
                                                    <v-list-item
                                                            v-if="user.status == 0"
                                                            class="hover:bg-gray-200"
                                                    ><v-list-item-title
                                                    ><a
                                                            href="javascript: void(0);"
                                                            @click="enableAccess(user)"
                                                    ><span class="table-menu-action-icon"
                                                    ><i class="fa fa-check"></i
                                                    ></span>
                                                        Enable Access</a
                                                    ></v-list-item-title
                                                    ></v-list-item
                                                    >
                                                </v-list>
                                            </v-menu>
                                </div>

                                <div class="dashboard-box-iconsquare">
                                    <div class="dashboard-box-icon-background"></div>
                                    <div class="dashboard-box-icon">
                                        <i class="mdi mdi-widgets-outline"></i>
                                    </div>
                                </div>

                                <div style="text-align: center">
                                    <div class="pt-2 pb-2">
                                        <strong
                                        >{{ user.first_name }} {{ user.last_name }}</strong>
                                    </div>

                                    <div>
                                        <div class="text-sm mb-2 text-gray-600">
                                            {{ formatDate(user.created_at) }} ·
                                            {{ user.email }}
                                        </div>

                                        <v-chip
                                                v-if="user.status == 1"
                                                small
                                                color="green lighten-5"
                                                text-color="green lighten-1"
                                        >
                                            Enabled
                                        </v-chip>

                                        <v-chip
                                                v-if="user.status == 0"
                                                small
                                                color="grey lighten-3"
                                                text-color="grey"
                                        >
                                            Disabled
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
                <div v-else class="dashboard-box">
                    <v-card class="pa-2" tile>
                        <div class="p-3">
                            <div class="justify-between items-start mb-3 float-right">
                                <v-menu bottom left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                                v-bind="attrs"
                                                v-on="on"
                                                class="flex flex-row items-center px-4 py-2 rounded border-1 border-gray-500 text-xs text-gray-600 cursor-pointer"
                                        >
                                            <span class="mr-2">Actions</span>
                                            <span class="text-xs" style="padding-top: 3px"></span>
                                        </div>
                                    </template>

                                    <v-list class="table-menu-actions">
                                        <v-list-item class="hover:bg-gray-200"
                                        ><v-list-item-title
                                        ><a href="javascript: void(0);" @click="bulkDelete()"
                                        ><span class="table-menu-action-icon"
                                        ><i class="fa fa-trash"></i
                                        ></span>
                                            Delete</a
                                        ></v-list-item-title
                                        ></v-list-item
                                        >
                                    </v-list>
                                </v-menu>
                            </div>

                            <br clear="all" />

                            <div class="" style="margin-top: -50px;">
                                <v-data-table
                                    :headers="headers"
                                    :items="users"
                                    :items-per-page="20"
                                    class="rg-datatable elevation-1"
                                    :footer-props="{
                                    itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                                    showFirstLastPage: true
                                    }"
                                    mobile-breakpoint="10"
                                    :search="search"
                                    show-select
                                    v-model="selected"
                                    item-key="id"
                                    >
                                        <template v-slot:top>
                                            <v-text-field
                                            clearable
                                            outlined
                                            dense
                                            hide-details
                                            prepend-inner-icon="mdi-magnify"
                                            label="Search"
                                            v-model="search"

                                            class="white border border-white"
                                            style="width: 100%; max-width: 300px; margin-bottom: 10px;"
                                            ></v-text-field>
                                        </template>

                                        <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                            <v-simple-checkbox
                                                :value="isSelected"
                                                :readonly="item.uuid == me.uuid"
                                                :disabled="item.uuid == me.uuid"
                                                @input="select($event)"
                                            ></v-simple-checkbox>
                                        </template>

                                        <template v-slot:item.first_name="{ item }">
                                            {{ item.first_name }} {{ item.last_name }}
                                        </template>
                                        
                                        <template v-slot:item.email="{ item }">
                                            {{ item.email ? item.email : '-' }}
                                        </template>
                                        
                                        <template v-slot:item.settings.role="{ item }">
                                            {{ ((item.uuid == me.uuid) ? "Owner" : (item.settings.role || "Owner")) }}
                                        </template>

                                        <template v-slot:item.created_at="{ item }">
                                            {{ formatDate(item.created_at) }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip
                                                    v-if="item.status == 1"
                                                    small
                                                    color="green lighten-5"
                                                    text-color="green lighten-1"
                                            >
                                                Enabled
                                            </v-chip>

                                            <v-chip
                                                    v-if="item.status == 0"
                                                    small
                                                    color="grey lighten-3"
                                                    text-color="grey"
                                            >
                                                Disabled
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.id="{ item }">
                                            <v-menu bottom left>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                                dark
                                                                icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                class="ml-3"
                                                                color="grey darken-1"
                                                        >
                                                            <i class="mdi mdi-dots-vertical"></i>
                                                        </v-btn>
                                                    </template>

                                                    <v-list class="table-menu-actions">
                                                        <v-list-item class="hover:bg-gray-200"
                                                            v-show="item.settings.role"
                                                        ><v-list-item-title
                                                        ><a
                                                                href="javascript: void(0);"
                                                                @click="
                                        $refs.dialogAddUser.editUser(item);
                                        $refs.dialogAddUser.show();
                                    "
                                                        ><span class="table-menu-action-icon"
                                                        ><i class="mdi mdi-pencil-outline"></i
                                                        ></span>
                                                            Edit</a
                                                        ></v-list-item-title
                                                        ></v-list-item
                                                        >
                                                        <v-list-item class="hover:bg-gray-200"
                                                        ><v-list-item-title
                                                        ><a
                                                                href="javascript: void(0);"
                                                                @click="checkResetPassword(item);"
                                                        ><span class="table-menu-action-icon"
                                                        ><i class="mdi mdi-logout"></i
                                                        ></span>
                                                            Resend Password</a
                                                        ></v-list-item-title
                                                        ></v-list-item
                                                        >
                                                        <v-list-item
                                                                v-if="item.status == 1"
                                                                v-show="item.uuid != me.uuid"
                                                                class="hover:bg-gray-200"
                                                        ><v-list-item-title
                                                        ><a
                                                                href="javascript: void(0);"
                                                                @click="disableAccess(item)"
                                                        ><span class="table-menu-action-icon"
                                                        ><i class="mdi mdi-close"></i
                                                        ></span>
                                                            Disable Access</a
                                                        ></v-list-item-title
                                                        ></v-list-item
                                                        >
                                                        <v-list-item
                                                                v-if="item.status == 0"
                                                                class="hover:bg-gray-200"
                                                        ><v-list-item-title
                                                        ><a
                                                                href="javascript: void(0);"
                                                                @click="enableAccess(item)"
                                                        ><span class="table-menu-action-icon"
                                                        ><i class="fa fa-check"></i
                                                        ></span>
                                                            Enable Access</a
                                                        ></v-list-item-title
                                                        ></v-list-item
                                                        >

                                                        <v-list-item
                                                                v-show="item.uuid != me.uuid"
                                                                class="hover:bg-gray-200"
                                                        ><v-list-item-title
                                                        ><a
                                                                href="javascript: void(0);"
                                                                @click="setAsOwner(item)"
                                                        ><span class="table-menu-action-icon"
                                                        ><i class="mdi mdi-account"></i
                                                        ></span>
                                                            Set as Owner</a
                                                        ></v-list-item-title
                                                        ></v-list-item
                                                        >
                                                    </v-list>
                                                </v-menu>
                                        </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-card>
                </div>
            </template>
        </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import MenuUserActions from "@/components/menus/menuUserActions.vue";
import DialogAddUser from "@/components/dialogs/users/addUser.vue";
import moment from "moment";

export default {
    components: {
        MenuUserActions,
        DialogAddUser,
    },
    data() {
        return {
            selected: [],
            selectedIds: [],

            search: "",

            headers: [
                { text: 'Name', value: 'first_name' },
                { text: 'Email', value: 'email' },
                { text: 'Role', value: 'settings.role' },
                { text: 'Added', value: 'created_at' },
                { text: 'Access', value: 'status' },
                { text: '', value: 'id', sortable: false }
            ]
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.users.users,
            fetchingUsers: (state) => state.users.fetchingUsers,
            me: (state) => state.me.me,
        }),
        sortedUsers() {
            return this.users
                .slice()
                .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        },
    },
    methods: {
        async setAsOwner(user) {
            let response = await axios.get(
                `${process.env.VUE_APP_API_ENDPOINT}/me/set-user-owner?uuid=${user.uuid}`,
                {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.auth.jwt,
                    },
                }
            );

            window.location = window.location.href;
        },

        checkResetPassword(user) {
            let self = this;

            this.$swal({
                title: "Are you sure?",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: "No",
                showLoading: true,
                html: "This action will reset <strong>" + user.first_name + "'s</strong> password and will send their new login via email.",
            }).then(function(result) {
                if (result.isConfirmed) {
                    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/reset-password`, {
                        uuid: user.uuid
                    }, {
                    headers: {
                        'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                    }
                    }).then(function() {
                        self.$swal({
                            title: "Password Reset!",
                            text: "Password reset and email to the user successfully!",
                            showCancelButton: false,
                        });
                    });
                }
            });
        },
        async bulkDelete() {
            await this.$store.dispatch("users/bulkDelete", { Ids: this.selectedIds });
            this.$store.dispatch("users/fetch");
            this.selected = []
            this.selectedIds = []
        },

        async disableAccess(business) {
            this.$store.state.users.fetchingUsers = true;

            let response = await axios.post(
                `${process.env.VUE_APP_API_ENDPOINT}/agency/disable-access`,
                {
                    uuid: business.uuid,
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.auth.jwt,
                    },
                }
            );

            this.$store.dispatch("users/fetch");
        },

        async enableAccess(business) {
            this.$store.state.users.fetchingUsers = true;

            let response = await axios.post(
                `${process.env.VUE_APP_API_ENDPOINT}/agency/enable-access`,
                {
                    uuid: business.uuid,
                },
                {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.auth.jwt,
                    },
                }
            );

            this.$store.dispatch("users/fetch");
        },

        formatDate(date) {
            return moment(date).format("MMM D, YYYY");
        },
    },
    mounted() {
        this.$store.state.users.fetchingUsers = true;
        this.$store.dispatch("users/fetch");
    },
    watch: {
        selected: {
        handler() {
            this.selectedIds = [];

            for (var i in this.selected) {
                this.selectedIds.push(this.selected[i].id);
            }
        }
        }
    },
};
</script>

<style lang="scss" scoped>
.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  // Box.
  & + label:before {
    content: "";
    margin-right: 0px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: rgb(228, 228, 228);
  }

  // Box hover
  /*&:hover + label:before {
    background: #f35429;
  }*/

  // Box focus
  &:focus + label:before {
    border-width: 0;
  }

  // Box checked
  &:checked + label:before {
    background: #48bb78;
  }

  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: "";
    position: absolute;
    left: 5px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white,
    4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(45deg);
  }
}

.btn-invite {
  background-color: #00ad9e;
}

table tbody tr {
  transition: all 0.1s linear;
}

table tbody tr:hover {
  background-color: rgb(245, 245, 245);
}
</style>